<gc-text>{{ sectionDescription }}</gc-text>

@if (isEditMode) {
  <app-text-input
    [data]="textInputData"
    [optionsButton]="false"
    [isComment]="true"
    (saveInput)="handleMarkAsNA($event)"
    (cancel)="handleCancel()"
  />
} @else {
  <div class="text-container">
    <gc-text [variant]="'informationBold'">{{
      'reportInput.description' | translate
    }}</gc-text>
    <gc-text>{{ comment }}</gc-text>
  </div>
  <app-options-button [type]="'N/A'" [isDone]="true" [id]="id" />
}
